// src/js/components/seo/seo-head.js
import React from 'react';
import { Helmet } from 'react-helmet';
import { SITE_NAME, DEFAULT_OG_IMAGE, TWITTER_HANDLE } from '../../constants/seo-config';

const SEOHead = ({
  title,
  description,
  canonical,
  ogType = 'website',
  ogImage = DEFAULT_OG_IMAGE,
  ogImageAlt = 'Neurochecklists — Evidence-based neurology checklists',
  ogImageWidth = 680,
  ogImageHeight = 680,
  keywords,
  noindex = false,
  structuredData,  // JSON-LD object
  children
}) => (
  <Helmet>
    {/* Primary Meta Tags */}
    <title>{title}</title>
    <meta name="description" content={description} />  {/* ← NOTE: "content" not "contents" */}
    {keywords && <meta name="keywords" content={keywords} />}
    {canonical && <link rel="canonical" href={canonical} />}
    {noindex && <meta name="robots" content="noindex, nofollow" />}

    {/* Open Graph */}
    <meta property="og:site_name" content={SITE_NAME} />
    <meta property="og:type" content={ogType} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    {canonical && <meta property="og:url" content={canonical} />}
    <meta property="og:image" content={ogImage} />
    <meta property="og:image:alt" content={ogImageAlt} />
    <meta property="og:image:width" content={String(ogImageWidth)} />
    <meta property="og:image:height" content={String(ogImageHeight)} />
    <meta property="og:locale" content="en_GB" />

    {/* Twitter Card */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content={TWITTER_HANDLE} />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={ogImage} />

    {/* Structured Data */}
    {structuredData && (
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    )}

    {children}
  </Helmet>
);

export default SEOHead;
